import {
    DomUtil,
    RGBA,
    Localization,
    DataColumnsDisplayMode,
    GraphicFilterOuterGlow,
    GraphicFilterDropShadow,
    DataColumn,
    DataEnum,
    KendoComponentFactory,
    BoundProperty,
    CvComponentFactory,
} from "cartovista";
import JSONFlowConnector from './JSONFlowConnector';
import "../../../css/Flow.css";﻿
             
export default class Flow {
    constructor() {
        this._map = window.cartovista.externalInterface.map;
        this._mapController = window.cartovista.getMapController(this._map);

        this._toolbar = window.cartovista.getUIController(this._map).findInstance("toolbar");
		this.flowOriginTool = window.cartovista.getUIController(this._map).findInstance("flowOriginTool");
		this.flowDestinationTool = window.cartovista.getUIController(this._map).findInstance("flowDestinationTool");

        this.initializeApp();
    }
		
    initializeApp(){
        //Configure flow controller
		this._flowController = window.cartovista.getFlowController();
		this._flowController.showLoopbackArrow = C.MAP_TOOLS.FLOWS_PROPERTIES.SHOW_LOOPBACK_ARROW;
		this._flowController.isLoopbackSizeFixed = C.MAP_TOOLS.FLOWS_PROPERTIES.IS_LOOPBACK_SIZE_FIXED;
		this._flowController.showArrowheads = C.MAP_TOOLS.FLOWS_PROPERTIES.SHOW_ARROW_HEADS;
		this._flowController.maximumNumberOfFlowArrow = C.MAP_TOOLS.FLOWS_PROPERTIES.MAXIMUM_NUMBER_OF_ARROW;

		this._jsonFlowConnector = new JSONFlowConnector();
		var flowInitializedSuccess = this._flowController.initializeController(this._jsonFlowConnector, null, this._map);
		if (!flowInitializedSuccess) {
			console.warn("Error initializing the flow controller.");
		} else {
			this.initializeFlowLayer();
		}
		
		this.initFlowPanel();
		this._map.addEventListener(this._map.EVENTS.ACTIVE_THEME_SET_CHANGED, this._onActiveThemeSetChanged, this);
    };

	initializeFlowLayer(){
		var dataColumnValue = this._flowController.flowLayer.attributesDataTable.getDataColumns(["Value"])[0];
		dataColumnValue.name = "Flux migratoire";
		dataColumnValue.units = "Personnes" || null;

		this._flowController.flowLayer.dataTipDataColumns.splice(1, 1);
		this._flowController.flowLayer.dataTipDataColumnsDisplayMode = DataColumnsDisplayMode.NONE;

		 //Set the flow layer name and apply layer effects....
		this.flowLayer = this._flowController.flowLayer;
		this.flowLayer.name = "Flux";
		this.flowLayer.opacity = 0.7;

		var graphicFilterEffectsG = new GraphicFilterOuterGlow();
		graphicFilterEffectsG.alpha = 0.9;
		graphicFilterEffectsG._blurX = 1;
		graphicFilterEffectsG._blurY = 1;
		graphicFilterEffectsG.strength = 1;
		graphicFilterEffectsG.color = new RGBA(255, 255, 255, 255);
		this.flowLayer.graphicFilterEffects.push(graphicFilterEffectsG);

		var graphicFilterEffects = new GraphicFilterDropShadow();
		graphicFilterEffects.alpha = 0.6;
		graphicFilterEffects._blurX = 2;
		graphicFilterEffects._blurY = 2;
		graphicFilterEffects.strength = 1;
		graphicFilterEffects.distance = 1;
		graphicFilterEffects.color = new RGBA(0, 0, 0, 255);
		this.flowLayer.graphicFilterEffects.push(graphicFilterEffects);

		//Add new data column for the percentage of commutes
		this.percentValueDC = new DataColumn("ValuePercent", DataEnum.NUMBER);
		this.percentValueDC.name = "Flux migratoire";
		this.percentValueDC.units = "%";
		this.percentValueDC.decimalPlaces = "2";
		this.flowLayer.attributesDataTable.addDataColumns([this.percentValueDC]);
		this.flowLayer.dataTipDataColumns = this.flowLayer.dataTipDataColumns.concat(this.percentValueDC);
		this.flowLayer.infoViewDataColumns = this.flowLayer.infoViewDataColumns.concat(this.percentValueDC);
		this.flowLayer.dataViewDataColumns = this.flowLayer.dataViewDataColumns.concat(this.percentValueDC);

		//Get data columns required later
		this.referenceFeatureDC = this.flowLayer.attributesDataTable.getDataColumns(["ReferenceFeature"])[0];

		//Add listeners to update the percentage values
		this.flowLayer.addEventListener(this.flowLayer.EVENTS.FEATURES_ADDED, this._onFeaturesAdded, this);
		this.valueDC = this.flowLayer.attributesDataTable.getDataColumns(["Value"])[0];
		this.valueDC.addEventListener(this.valueDC.EVENTS.VALUES_UPDATED, this._onDataColumnValuesUpdated, this);

	}

	/**
	 * @private
	 * Listener for Map.EVENTS ACTIVE_THEME_SET_CHANGED.
	 *
	 * @method _onActiveThemeSetChanged
	 * @param {cartovista.viewer.events.DBxEvent} dbxEvent The event received.
	 */
	_onActiveThemeSetChanged(evt) {
		//Show/hide flow tool
		if (this._map.activeThemeSet && this._map.activeThemeSet.toString() == "FlowThemeSet") {
			if(this.flowOriginTool) this.flowOriginTool.element.classList.remove("cv-invisible");
			if(this.flowDestinationTool) this.flowDestinationTool.element.classList.remove("cv-invisible");
		} else {
			this._flowController.removeFlows();
			if(this.flowOriginTool) this.flowOriginTool.element.classList.add("cv-invisible");
			if(this.flowDestinationTool) this.flowDestinationTool.element.classList.add("cv-invisible");

			//If one of the flow tool is selected, chaneg to another one
			var selectedTool = this._toolbar.getToggledTool();
			if (!selectedTool || selectedTool.toString().toLowerCase().indexOf("flow") >= 0) {
				var infoPanTool = window.cartovista._coreObject.findInstance("infoPanTool");
				if (infoPanTool) {
					infoPanTool.toggleOn();
				} else {
					var panTool = window.cartovista._coreObject.findInstance("panTool");
					if (panTool) {
						panTool.toggleOn();
					}
				}
			}
		}
	};

    _onToggle_showArrowheads(checked) {
		this._flowController.showArrowheads = checked;
	};
	
	_onToggle_showInternalFlows(checked) {
		this._flowController.showLoopbackArrow = checked;
	};
	
    _removeFlows() {
		this._flowController.removeFlows();
	};

	_onFeaturesAdded(layerFeaturesAddedEvent) {
		var features = layerFeaturesAddedEvent.features;
		this._updatePourcentValues(features);
	};

	_onDataColumnValuesUpdated(dbxEvent) {
		this._updatePourcentValues(null);
	};

	_updatePourcentValues(features) {
		var featureIds = null;
		if (typeof features !== 'undefined' && features !== null) {
			featureIds = features.map(function(feature) {
				return feature.id;
			});
		}
		var dataQuery = this.flowLayer.createDataQuery(this.flowLayer.attributesDataTable.dataColumns, featureIds, null, null, null)
		dataQuery.execute(function(result) {
			var data = [];
			var featureDataIds = [];
			var n = result.values[this.valueDC.dataTable.id][this.valueDC.id].length;
			for (var i = 0; i < n; i++) {
				var value = result.values[this.valueDC.dataTable.id][this.valueDC.id][i];
				var featureId = result.linkingIds[i];
				featureDataIds.push(featureId);
				var referenceFeatureValue = result.values[this.referenceFeatureDC.dataTable.id][this.referenceFeatureDC.id][i];
				var odFeatureId;
				var flowType;
				if (referenceFeatureValue.indexOf(Localization.getValue("flowLayer.origin")) >= 0) {
					flowType = "origin";
					odFeatureId = result.values[this.flowLayer.attributesDataTable.id]["originFeatureId"][i];
				} else {
					flowType = "destination"
					odFeatureId = result.values[this.flowLayer.attributesDataTable.id]["destinationFeatureId"][i];
				}
				var totalValue = this._jsonFlowConnector.totalValues[odFeatureId + "." + flowType];
				data.push(value / totalValue * 100);
			}

			this.flowLayer.attributesDataTable.updateValues(this.percentValueDC, featureDataIds, data);

		}, this);
	};

	initFlowPanel() {
		this._myGenericViewContainer = document.getElementById("Flow_panel-content");

		if (this._myGenericViewContainer) {
			//Title
			this.lblTitle = DomUtil.createElement(this._myGenericViewContainer, "div", null, "flowTitle");
			this.lblTitle.innerHTML = "Thématique de flux";

			//Options
			this.lblSubTitleOptions = DomUtil.createElement(this._myGenericViewContainer, "div", null, "flowSubTitle");
			this.lblSubTitleOptions.innerHTML = "Options";

			//Maximum number of flows to display
			var nbFlowsContainer = DomUtil.createElement(this._myGenericViewContainer, "div", null, "flowPanelLine");
			this.lblNbFlows = DomUtil.createElement(nbFlowsContainer, "label", null, "leftContent");
			this.lblNbFlows.innerHTML = "Nombre de flux";
			this.dropDownNbFlows = KendoComponentFactory.createComboBox(nbFlowsContainer, {
				id: this.id + '-dropDownNbFlows',
				classNames: "rightContent dropDownNbFlows",
				//dataTextField: "text",
				//dataValueField: "id",
				initialValues: [1, 2, 4, 6, 10, 20],
				boundProperty: new BoundProperty(this._flowController, "maximumNumberOfFlowArrow", this._flowController.EVENTS.NUMBER_FLOW_CHANGED),
			});

			//Show Arrowheads
			var showArrowHeadsContainer = DomUtil.createElement(this._myGenericViewContainer, "div", null, "flowPanelLine flowToggleLine");
			this.lblShowArrowHeads = DomUtil.createElement(showArrowHeadsContainer, "label", null, "leftContent");
			this.lblShowArrowHeads.innerHTML = "Montrer les têtes de flèches";

			CvComponentFactory.createToggleSwitch(showArrowHeadsContainer, {
				id: "showArrowheads-switch",
				classNames: "rightContent",
				state: this._flowController.showArrowheads,
				onToggle: this._onToggle_showArrowheads.bind(this)
			});

				
			//Internal FLow Arrow
			var internalFlowContainer = DomUtil.createElement(this._myGenericViewContainer, "div", null, "flowPanelLine flowToggleLine");
			this.lblInternalFlow = DomUtil.createElement(internalFlowContainer, "label", null, "leftContent");
			this.lblInternalFlow.innerHTML = "Inclure les flux interne";

			CvComponentFactory.createToggleSwitch(internalFlowContainer, {
				id: "showInternalFlows-switch",
				classNames: "rightContent",
				state: this._flowController.showLoopbackArrow,
				onToggle: this._onToggle_showInternalFlows.bind(this)
			});
				

			//Remove Flows
			var removeFlowsContainer = DomUtil.createElement(this._myGenericViewContainer, "div", null, "flowPanelLine flowButtonLine");
			this.btnRemoveFlows = DomUtil.createElement(removeFlowsContainer, "button", null, "leftContent k-button removeFlowsBtn");
			this.btnRemoveFlows.innerHTML = "Effacer les flux";
			this.btnRemoveFlows.addEventListener("click", this._removeFlows.bind(this));
		}
	};
}